"use client";

import { useClientOnly } from "./useHydration";

interface ClientOnlyProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export default function ClientOnly({ children, fallback = null }: ClientOnlyProps) {
  const mounted = useClientOnly();

  if (!mounted) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
